import React from 'react';
import { Tag, TagSize } from '../Tag/Tag';
import { camelize } from 'humps';
import { DeliveryStatus } from '../../model/delivery';
import { EventStatus } from '../../model/event';
import { ImportStatus } from '../../model/imports';
import { InvoiceStatus } from '../../model/invoice';
import { OrderStatus } from '../../model/order';
import { t } from '../../locales/translate';
import './StatusPill.css';

interface Props {
  status?:
    | EventStatus
    | OrderStatus
    | ImportStatus
    | InvoiceStatus
    | DeliveryStatus
    | 'scheduled'
    | 'active'
    | 'inactive'
    | 'private'
    | 'archived';
  label?: string;
  size?: TagSize;
}

export function StatusPill({ status, size, label }: Props): JSX.Element {
  if (!status) {
    return <span>-</span>;
  }
  return <Tag text={label ?? t.model.status[camelize(status)]} className={`status-pill--${status}`} size={size} />;
}
